export default __webpack_public_path__ + "static/media/menue_mobile.c8c3de15.svg";